/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    strong: "strong"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Vous trouverez ci-dessous le catalogue des recommandations sur la santé environnement constitué dans le cadre de la construction du service Recosanté et validé par le ", React.createElement(_components.strong, null, "Santé publique France"), "."), "\n", React.createElement(_components.p, null, "Les recommandations sont classées suivant leur thématique et sont adaptées à une situation environnementale donnée."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
